// extracted by mini-css-extract-plugin
module.exports = {"menu":"styles_menu__tr5j4","visible":"styles_visible__3Onnv","hidden":"styles_hidden__36NbP","linkIcon":"styles_linkIcon__36hso"};